module.exports = __webpack_public_path__ + "img/06.560a78b0.jpg";